export type BadgeType = 
  | 'first_expression'
  | 'love_ambassador'
  | 'relationship_celebrant'
  | 'birthday_champion'
  | 'friendship_keeper'
  | 'consistency_star';

export type LevelType = 
  | 'heart_opener'
  | 'soul_connector'
  | 'love_ambassador'
  | 'gratitude_champion'
  | 'legacy_maker';

export type DateType = 
  | 'birthday'
  | 'relationship_anniversary'
  | 'friendship_anniversary'
  | 'other';

export interface Badge {
  id: string;
  badge_key: BadgeType;
  name: string;
  description: string;
  icon: string;
  requirement_description: string;
  points: number;
  created_at: string;
}

export interface UserBadge {
  id: string;
  user_id: string;
  badge_id: string;
  earned_at: string;
  badge?: Badge;
}

export interface UserLevel {
  id: string;
  user_id: string;
  current_level: LevelType;
  total_points: number;
  badges_earned: number;
  updated_at: string;
}

export interface ImportantDate {
  id: string;
  user_id: string;
  recipient_name: string;
  date_type: DateType;
  date_value: string;
  notes?: string;
  created_at: string;
  updated_at: string;
}

export const LEVEL_CONFIG: Record<LevelType, { name: string; minPoints: number; icon: string; color: string }> = {
  heart_opener: { name: 'Heart Opener', minPoints: 0, icon: 'Heart', color: 'text-rose-500' },
  soul_connector: { name: 'Soul Connector', minPoints: 50, icon: 'Sparkles', color: 'text-purple-500' },
  love_ambassador: { name: 'Love Ambassador', minPoints: 100, icon: 'Award', color: 'text-blue-500' },
  gratitude_champion: { name: 'Gratitude Champion', minPoints: 175, icon: 'Trophy', color: 'text-amber-500' },
  legacy_maker: { name: 'Legacy Maker', minPoints: 250, icon: 'Crown', color: 'text-emerald-500' },
};

export const LEVEL_ORDER: LevelType[] = [
  'heart_opener',
  'soul_connector',
  'love_ambassador',
  'gratitude_champion',
  'legacy_maker',
];
